import React, { useState, useEffect, useRef } from "react";
import { motion, useTransform, useViewportScroll } from 'framer-motion';
import CSGoogleImage from "../../images/google-img.jpeg";
import CSMessengerImage from "../../images/messenger-img.jpeg";
import CSEGitImage from "../../images/git-img.jpeg";
import CSEBPMessageImage from "../../images/massage-img.jpeg";
import CSEBAppleImage from "../../images/apple-img.jpeg";
import InView from "react-intersection-observer";

export default function KrogerCsEbusiness(props) {
  const [elementTop, setElementTop] = useState(0);
  const [elementBottom, setElementBottom] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [clientHeight, setClientHeight] = useState(0);
  const { scrollY } = useViewportScroll();
  const yOffset = 150;
  const easing = [0.42, 0, 0.58, 1];
  const ref = useRef();

  const setValues = () => {
    setElementTop(ref.current.offsetTop);
    //console.log('setting values in mobile intro: ', ref.current.offsetTop);
    setElementBottom(ref.current.offsetTop + ref.current.offsetHeight);
    setClientHeight(window.innerHeight);
  };

  useEffect(() => {
    if (!ref.current) return;
    props.isLoaded && setValues();
    window.addEventListener('resize', setValues);
    document.addEventListener('load', setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  });
  const y0 = useTransform(scrollY, [elementTop - clientHeight * 0.9, elementTop - clientHeight / 6], [yOffset, 0], easing);
  const variants = {
    hidden: {
      scale: 0,
      opacity: 0
    },
    show: {
      scale: 1,
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1,
        ease: [0.42, 0, 0.58, 1],
        duration: 0.3
      },
    }
  };
  return (
    <div className="cs-services-section">
      <div className="">
        <div className="container-small">
          <div ref={ref} className="services-inner">
            <div className="row d-flex flex-wrap align-v-center">
              <InView as="div" className="col" onChange={(inView) => setIsVisible(inView)} threshold={[0.3]} triggerOnce>
                <motion.div
                  initial="hidden"
                  animate={isVisible ? "show" : "hidden"}
                  variants={variants}
                  className="services-icon-wrapper">
                  <motion.img variants={variants} src={CSGoogleImage} alt="Google Assistant" title="Google Assistant" />
                  <motion.img variants={variants} src={CSMessengerImage} alt="Messenger" title="Messenger" />
                  <motion.img variants={variants} src={CSEGitImage} alt="Alexa" title="Alexa" />
                  <motion.img variants={variants} src={CSEBPMessageImage} alt="chatbot" title="chatbot" />
                  <motion.img variants={variants} src={CSEBAppleImage} alt="Siri" title="Siri" />
                </motion.div>
              </InView>
              <div className="col">
                <h3>Enabling brand new <br /> voice-enabled experiences</h3>
                <p>With a well-informed platform roadmap, our client team and we continue to improve experiences and launch new voice-enabled services.</p>
                <ul className="checkmark-ul two-column">
                  <li>Aisle Location</li>
                  <li>Store Locator</li>
                  <li>Pharmacy</li>
                  <li>Amazon Alexa</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}